module.exports = __webpack_public_path__ + "img/GsNeverAllowed.a09c0809.png";